import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {accessConstants, authUtils, UnpauseLessonAction, ReloadListAction} from "mindsets-js-sdk";

const UnpauseMenuItem = function ({id, status}) {
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_ALL_LESSONS]) && 'paused' === status) {
        return (
            <button className='button mx-2 my-1' onClick={event => {
                event.preventDefault();
                dispatch(UnpauseLessonAction(id)).then(() => dispatch(ReloadListAction(true, 'lessons')));
            }}>Resume</button>
        );
    }

    return null;
}

UnpauseMenuItem.propTypes = {
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired
}

export default UnpauseMenuItem;
